// eslint-disable-next-line import/no-cycle
import store from '@client/store';
// eslint-disable-next-line import/no-cycle
import accountRequest from '@client/services/accountRequest';
import {Route, NavigationGuardNext} from 'vue-router';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getPendingRequestQueryParam = async () => {
  const pendingAccounts = await accountRequest.getPending({
    clUserId: store.state.cognitoUser.user.userId,
  });

  let queryParams = {};

  if (pendingAccounts.length > 0) {
    queryParams = {
      query: {
        req_id: pendingAccounts[0].id,
      },
    };
  }

  return queryParams;
};

/**
 * if cdo flag is set redirect to the onboarding screens
 */
const cdo = async (to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
  if (to.meta.isLoginRoute || to.meta.cdo || to.meta.publicRoute) {
    next();

    return;
  }

  await store.dispatch('onboarding/findOnboarding');
  const {cdo: cdoSettingsInState, ria} = store.state.settings;
  const cdoSettings = cdoSettingsInState || (await store.dispatch('settings/getCdoSettings'));

  if (store.state.onboarding.active) {
    const query = await getPendingRequestQueryParam();

    next({
      name: 'Onboarding',
      params: {
        cdoparameter: cdoSettings?.linkAlias || ria.cdoParameter,
      },
      ...query,
    });

    return;
  }

  next();
};

export default cdo;
